module.exports = __webpack_public_path__ + "static/media/getFetch.8b23441a.cjs";